var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-return",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#e3e3e3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_move_here_B",
    "data-name": "icon move here B",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-background",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(21.166 -34.509) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M10.663,2.06a.807.807,0,0,0-.858.158l-.02.019L5.458,6.564A.806.806,0,1,0,6.6,7.7L9.551,4.752v8.442a.806.806,0,0,0,1.612,0V4.752L14.115,7.7a.806.806,0,0,0,1.14-1.14L10.926,2.236A.8.8,0,0,0,10.663,2.06Z",
    transform: "translate(19.166 -55) rotate(90)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.d72a83c5718935bd9c05448e4913f9e0.svg";
export { ForwardRef as ReactComponent };